const viewports = [
  'sm',
  'md',
  'lg'
]

/**
 * Validates the specified viewport string. If invalid, throws an error.
 * @param {string} viewport
 */
export function validate (viewport) {
  if (!viewport || viewports.includes(viewport)) return true
  throw new Error(`Viewport "${viewport}" is invalid and must be one of [${viewports.join(',')}]`)
}

export default viewports
